export const NEW_DATA_EVENT = "NEW_DATA_EVENT";
export const PAUSE_TIMER_EVENT = "PAUSE_TIMER_EVENT";
export const RESUME_EVENT_TIMER = "RESUME_EVENT_TIMER";